"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildDateMatrix = buildDateMatrix;
exports.buildDisplayMonth = buildDisplayMonth;

var _isDate = _interopRequireDefault(require("lodash/isDate"));

var _range = _interopRequireDefault(require("lodash/range"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/**
 * Evaluates a displayMonth to determine the index of the first day within the first
 * week of the month.
 */


function getFirstDayOfMonthIndex(displayMonth) {
  var date = new Date(displayMonth.year, displayMonth.month - 1, 1);
  return date.getDay();
}

function buildDefaultDisplayDate(displayMonth, dateOfMonth) {
  var year = displayMonth.year,
      month = displayMonth.month;
  return {
    year: year,
    month: month,
    date: dateOfMonth,
    // isInActiveRange: false,
    isInSelectedRange: false,
    isSelected: false,
    isToday: false,
    isDisabled: false,
    isInActiveRange: false
  };
}
/**
 * Builds a matrix based on the provided displayMonth that determines how many weeks
 * the month spans, and what position within those weeks the dates should be in.
 */


function buildDateMatrix(displayMonth) {
  // This gets the index of the first of the month within the first week. Ex, if the first is a
  // Wednesday, the firstDayIndex will be 4.
  var firstDayIndex = getFirstDayOfMonthIndex(displayMonth);

  if (!displayMonth.daysInMonth) {
    throw new Error('Error while building Date Matrix. The days in the month must be provided in the display month.');
  }

  var daysInMonth = displayMonth.daysInMonth;
  var daysInMonthInLastWeek = (daysInMonth + firstDayIndex) % 7; // If daysInMonthInLastWeek is 0, use that, otherwise fill in the rest of the
  // week with the days needed.

  var emptyTrailingDaysCount = daysInMonthInLastWeek ? 7 - daysInMonthInLastWeek : daysInMonthInLastWeek; // This creates an incrementing array the length of the days in the month
  // plus the days in the first week that are not a part of this month and the days
  // in the last week that are not a part of this month. Should always be evenly divisible
  // by 7.

  var totalDaysInDateMatrix = (0, _range.default)(0, daysInMonth + firstDayIndex + emptyTrailingDaysCount); // Converts array the length of the total days in the calendar into an array of weeks with
  // properly indexed display dates.

  return totalDaysInDateMatrix.reduce(function (acc, index) {
    // Evaluates whether the current index refers to one of the days in the month,
    // or before this month begins
    var buildingCurrentMonth = firstDayIndex <= index && index - firstDayIndex + 1 <= daysInMonth; // Creates the correct date for this index, or null

    var dateOfMonth = buildingCurrentMonth ? index - firstDayIndex + 1 : null; // Creates a display date object for the date of the month

    var displayDate = dateOfMonth ? buildDefaultDisplayDate(displayMonth, dateOfMonth) : null; // Evaluates the index to determine if this should be the start of a new week.

    var buildingNewWeek = index % 7 === 0; // If the current index is the first in the week, adds a new array with the correct date at
    // index 0

    if (buildingNewWeek) {
      var newWeek = [displayDate];
      return [].concat(_toConsumableArray(acc), [newWeek]);
    } // If the current index is not the first in the week, appends the correct date to the last
    // week array.


    acc[acc.length - 1].push(displayDate);
    return acc;
  }, []);
}
/**
 * Generates a displayMonth object for use in the Calendar.
 */


function buildDisplayMonth(date) {
  // Ensures we are working with the correct JavaScript date object.
  var jsDate = (0, _isDate.default)(date) ? date : new Date(date.year, date.month - 1, 1);
  return {
    year: jsDate.getFullYear(),
    month: jsDate.getMonth() + 1,
    daysInMonth: (0, _utils.getDaysInMonth)(jsDate)
  };
}